import {IWindowProxy} from './IWindowProxy';

export class WindowProxyImpl implements IWindowProxy {
    constructor(private source: MessageEventSource, private origin: string) {
    }

    public postMessage(payload: { data: any; eventName: string }): void {
        (this.source as WindowProxy).postMessage({
            eventName: payload.eventName,
            data: payload.data
        }, this.origin);
    }
}
